export interface IDateRange {
  start: { toString(): string };
  end: { toString(): string };
}

const formatDateRangeParams = (dateRange?: IDateRange): string => {
  if (!dateRange) {
    return '';
  }
  return `?start=${dateRange.start.toString()}&end=${dateRange.end.toString()}`;
};

export const PATHS = {
  HOME: '/',

  ACCOUNTS: '/accounts',
  DASHBOARD: '/dashboard',
  ACCOUNT: (accountId: string, dateRange?: IDateRange) => `/accounts/${accountId}${formatDateRangeParams(dateRange)}`,

  LOGIN: '/login',
  MERCHANTS: '/merchants',
  MERCHANT: (merchantId: string, dateRange?: IDateRange) =>
    `/merchants/${merchantId}${formatDateRangeParams(dateRange)}`,
  ONBOARDING: '/onboarding',
  OBLIGATIONS: '/obligations',
  PROCESSOR_STATUSES: '/admin/processor-statuses',
  SETTINGS: '/settings',
  SPENDING: (dateRange?: IDateRange) => `/spending${formatDateRangeParams(dateRange)}`,
  RECURRING_TRANSACTIONS: '/recurring-transactions',
  TRANSACTION_ROLLUPS: '/admin/transactions-chart-demo',
  ADMIN_IMPERSONATE_USER: '/admin/impersonateUser',
  ADMIN_BANK_CONNECTIONS: '/admin/bank-connections',
  ADMIN_BILL_MANAGMENT: '/admin/bill-managment',
  ADMIN_SENTRY_TEST: '/admin/sentry-test',
  ADMIN_ENVIRONMENT: '/admin/environment',
  ADMIN_ALPHA_ALLOW_LIST: '/admin/alpha-allow-list',
  ADMIN_USERS_WITH_TRANSACTION_REVIEWS: '/admin/users-with-transaction-reviews',
  ADMIN_CHAT: '/admin/chat',
  TRANSACTION_ANOMALY_FEEDBACK: '/transaction-anomaly-feedback',
  TRANSACTION_ANOMALY_FEEDBACK_FOR_USER: (userId: string) => `/transaction-anomaly-feedback/${userId}`,
} as const;

export type PathKey = keyof typeof PATHS;
export type PathValue = (typeof PATHS)[PathKey];
